export default function isDesktop() {
  return window.innerWidth > 1000;
}
